import { alert } from './reducers';
export default alert;
